import { createPureImageGridUtils } from './pureImageGrid.js';

const quad = createPureImageGridUtils({
	type: 'image-quad',
	colCount: 4,
	colGap: 3,
	defaultHeight: 100,
	defaultBorderRadius: 4,
	defaultItemCount: 8,
	imageIdPrefix: 'image-quad-item',
	randomStart: 91,
	assetKey: 'imgQuad',
});

export const IMAGE_QUAD_TYPE = quad.TYPE;
export const IMAGE_QUAD_DEFAULT_HEIGHT = quad.DEFAULT_HEIGHT;
export const IMAGE_QUAD_COL_COUNT = quad.COL_COUNT;
export const IMAGE_QUAD_COL_GAP = quad.COL_GAP;
export const IMAGE_QUAD_BATCH_SIZE = quad.BATCH_SIZE;

export const createDefaultImageQuadItem = quad.createDefaultItem;
export const createDefaultImageQuadItems = quad.createDefaultItems;
export const getImageQuadDefaults = quad.getDefaults;
export const isImageQuadBlock = quad.isBlock;
export const getImageQuadImageUrl = quad.getImageUrl;
export const normalizeImageQuadData = quad.normalizeData;
export const getImageQuadBlockStyle = quad.getBlockStyle;
export const getImageQuadGalleryUrls = quad.getGalleryUrls;
export const getImageQuadThumbAspectRatio = quad.getThumbAspectRatio;
